export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      ministries: 'Ministries',
      sermons: 'Sermons',
      livestream: 'Live Stream',
      resources: 'Resources',
      gallery: 'Gallery',
      donate: 'Donate',
      contact: 'Contact',
      admin: 'Admin'
    },
    home: {
      welcome: 'Welcome to',
      churchName: 'Mekane Hiwet Eyesus',
      subtitle: 'Eritrean Orthodox Tewahdo Church - Dallas, TX',
      description: 'A spiritual home where faith, community, and tradition unite in worship and service',
      watchLive: 'Watch Live',
      watchLatestSermons: 'Watch Latest Sermons',
      donate: 'Support Our Mission',
      upcomingServices: 'Upcoming Services',
      announcements: 'Announcements'
    },
    about: {
      title: 'About Us',
      historyTitle: 'Our History',
      purposeTitle: 'Our Purpose',
      visionTitle: 'Our Vision',
      contactInfo: 'Contact Information'
    },
    ministries: {
      title: 'Our Ministries',
      description: 'Serving our community through diverse programs that nurture faith, build relationships, and spread the love of Christ',
      activities: 'Activities:',
      stayConnected: 'Stay Connected',
      stayConnectedDesc: 'Join our community on social media and WhatsApp for updates about services, events, and prayer requests.',
      whatsappInstruction: 'Click the WhatsApp icon to join our community group',
      getInvolved: 'Get Involved',
      getInvolvedDesc: "Everyone is welcome to participate in our ministries. Whether you want to serve, learn, or fellowship, there's a place for you.",
      contactToStart: 'Contact Us to Get Started'
    },
    sermons: {
      title: 'Weekly Sermons',
      search: 'Search sermons by topic or date...',
      watching: 'Watching',
      noResults: 'No sermons found',
      loadMore: 'Load More'
    },
    livestream: {
      title: 'Live Stream',
      subtitle: 'Join us live for worship, prayer, and fellowship from anywhere',
      liveNow: 'LIVE NOW',
      watchingNow: 'Watching Now',
      noLiveStream: 'No Live Stream Currently',
      noLiveMessage: 'Watch our latest sermons or check the schedule below for upcoming services',
      watchLatestSermons: 'Watch Latest Sermons',
      visitYouTube: 'Visit Our YouTube Channel',
      startedAt: 'Started at',
      serviceSchedule: 'Service Schedule',
      serviceScheduleSubtitle: 'Join us for our regular worship services - streamed live',
      joinInPerson: 'Join Us In Person',
      currentMeetingLocation: 'Currently meeting at St. Philopatheer Coptic Orthodox Church',
      howToWatch: 'How to Watch'
    },
    resources: {
      title: 'Resources',
      subtitle: 'Find answers and submit requests for church services',
      requestForms: 'Request Forms',
      faqTitle: 'Frequently Asked Questions',
      back: 'Back',
      
      // Baptism Form
      baptismRequest: 'Baptism Request',
      baptismDescription: 'Request baptism for your child',
      baptismFormTitle: 'Baptism Request Form',
      childName: "Child's Full Name",
      dateOfBirth: 'Date of Birth',
      gender: 'Gender',
      selectGender: 'Select Gender',
      male: 'Male',
      female: 'Female',
      fatherName: "Father's Full Name",
      motherName: "Mother's Full Name",
      contactEmail: 'Contact Email',
      contactPhone: 'Contact Phone',
      preferredBaptismDate: 'Preferred Baptism Date',
      additionalNotes: 'Additional Notes',
      additionalNotesPlaceholder: 'Any additional information...',
      
      // Wedding Form
      weddingRequest: 'Wedding Request',
      weddingDescription: 'Request to schedule your church wedding',
      weddingFormTitle: 'Wedding Request Form',
      groomName: "Groom's Full Name",
      brideName: "Bride's Full Name",
      preferredWeddingDate: 'Preferred Wedding Date',
      
      // Counseling Form
      counselingRequest: 'Counseling Request',
      counselingDescription: 'Request spiritual or personal counseling',
      counselingFormTitle: 'Counseling Request Form',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      counselingType: 'Type of Counseling',
      selectType: 'Select Type',
      personal: 'Personal',
      family: 'Family',
      youth: 'Youth',
      other: 'Other',
      messageDetails: 'Message / Details',
      counselingPlaceholder: 'Please share details about your counseling request...',
      
      // Membership Form
      membershipRequest: 'Church Membership',
      membershipDescription: 'Apply to become a member of our church',
      membershipFormTitle: 'Church Membership Application',
      address: 'Address',
      whyJoin: 'Why do you want to join our church?',
      reasonPlaceholder: 'Please share your reasons for wanting to join our church...',
      
      // Form Actions
      submitting: 'Submitting...',
      submitRequest: 'Submit Request',
      baptismSuccess: 'Baptism request submitted! We will contact you soon.',
      weddingSuccess: 'Wedding request submitted! We will contact you soon.',
      counselingSuccess: 'Counseling request submitted! We will contact you soon.',
      membershipSuccess: 'Membership application submitted! We will contact you soon.',
      submitError: 'Failed to submit request'
    },
    gallery: {
      title: 'Photo Gallery',
      subtitle: 'Moments from our community',
      filterPhotos: 'Filter Photos',
      allDates: 'All Dates',
      allLocations: 'All Locations',
      clearFilters: 'Clear All Filters',
      showing: 'Showing',
      of: 'of',
      photos: 'photos',
      noPhotos: 'No photos to display'
    },
    donate: {
      title: 'Support Our Church',
      subtitle: 'Help us build a permanent home for our growing community',
      selectAmount: 'Select Donation Amount',
      packages: {
        small: 'Supporter',
        medium: 'Benefactor',
        large: 'Patron',
        generous: 'Generous Donor',
        other: 'Other',
        customAmount: 'Custom Amount'
      },
      donorInfo: 'Donor Information (Optional)',
      name: 'Full Name',
      email: 'Email Address',
      enterAmount: 'Enter Amount ($)',
      enterAmountPlaceholder: 'Enter amount',
      monthlyRecurring: 'Make this a monthly recurring payment (Tithe)',
      startMonthlyTithe: 'Start Monthly Tithe',
      submit: 'Proceed to Payment',
      success: 'Thank You!',
      successMessage: 'Your generous donation has been received. May God bless you!',
      processing: 'Processing your donation...',
      backToDonate: 'Make Another Donation',
      downloadReceipt: 'Download Receipt (PDF)',
      invalidAmount: 'Please enter a valid amount (minimum $1)',
      
      // Building Campaign
      buildingCampaign: 'Building Campaign',
      prayerSanctuary: 'Prayer Sanctuary',
      prayerDescription: 'For worship services, prayers, and spiritual gatherings',
      churchHall: 'Church Hall',
      churchHallDescription: 'For weddings, baptisms, memorials, and celebrations',
      youthMinistry: 'Youth Ministry',
      youthDescription: 'Religious education in English, library, play areas'
    },
    contact: {
      title: 'Contact Us',
      address: 'Address',
      email: 'Email',
      phone: 'Phone',
      followUs: 'Follow Us',
      sendMessage: 'Send Message',
      name: 'Name',
      message: 'Message',
      submit: 'Send'
    },
    admin: {
      title: 'Admin Panel',
      login: 'Admin Login',
      email: 'Email',
      password: 'Password',
      username: 'Username',
      signIn: 'Sign In',
      register: 'Register',
      dashboard: 'Dashboard',
      overview: 'Overview',
      allPages: 'All Pages',
      formSubmissions: 'Form Submissions',
      advancedContent: 'Advanced Content',
      content: 'Content Management',
      gallery: 'Gallery',
      announcements: 'Announcements',
      livestream: 'Live Stream',
      donations: 'Donations',
      logout: 'Logout',
      sessionExpired: 'Session expired. Please login again.',
      logoutSuccess: 'Logged out successfully'
    },
    footer: {
      description: 'Serving the Eritrean Orthodox Tewahdo community in Dallas and surrounding areas since 2016',
      quickLinks: 'Quick Links',
      connectWithUs: 'Connect With Us',
      copyright: '© 2025 Mekane Hiwet Eyesus Orthodox Tewahdo Church. All rights reserved.'
    }
  },
  ti: {
    nav: {
      home: 'ቀንዲ ገጽ',
      about: 'ብዛዕባና',
      ministries: 'ኣገልግሎታት',
      sermons: 'ስብከታት',
      livestream: 'ቀጥታ መድብ',
      resources: 'ሓበሬታ',
      gallery: 'ስእሊታት',
      donate: 'ደገፍ',
      contact: 'ርኸቡና',
      admin: 'ኣማሓዳሪ'
    },
    home: {
      welcome: 'እንቋዕ ብደሓን መጻእኩም',
      churchName: 'መካነ ህይወት ኢየሱስ',
      subtitle: 'ኤርትራዊት ኦርቶዶክስ ተዋሕዶ ቤተክርስትያን - ዳላስ፡ ቴክሳስ',
      description: 'እምነት፣ ሕብረትን ባህሊን ኣብ ኣምልኾን ኣገልግሎትን ዝጥርነፈሉ መንፈሳዊ ቤት',
      watchLive: 'ቀጥታ መድብ ተመልከቱ',
      watchLatestSermons: 'ሓድሽ ስብከታት ርአዩ',
      donate: 'ተልእኾና ደግፉ',
      upcomingServices: 'ዝመጽኡ ኣገልግሎታት',
      announcements: 'ምልክታታት'
    },
    about: {
      title: 'ብዛዕባና',
      historyTitle: 'ታሪኽና',
      purposeTitle: 'ዕላማና',
      visionTitle: 'ራእይና',
      contactInfo: 'ርኸቡና'
    },
     ministries: {
      title: 'ኣገልግሎታትና',
      description: 'ንማሕበረስብና ብዝተፈላለየ መደባት ብምግልጋል፡ ፍቅሪ ክርስቶስ ንምዝርጋሕን፡ እምነትና ንምህናጽ፡ ርክብና ነድልደል',
      activities: 'ስራሕቲ:',
      stayConnected: 'ተራኸቡ',
      stayConnectedDesc: 'ንስራሕቲ፡ ብዛዕባ ኣገልግሎታት፡ ፍጻሜታትን ሕቶታት ጸሎትን ሓድሽ ሓበሬታ ንምርካብ ኣብ ማሕበራዊ መራኸቢታትን ዋትስኣፕን(WhatsApp)ኣብ ማሕበረሰብና ተጸንበሩ።',
      whatsappInstruction: 'ናብ ናይ ዋትስኣፕ (WhatsApp) ማሕበረሰብ ጉጅለ ንምእታው ኣብዚ ጠውቑ',
      getInvolved: 'ተሳተፉ',
      getInvolvedDesc: 'ኩሉ ሰብ ኣብ ኣገልግሎትና ክሳተፍ ዑድም እዩ። ከተገልግል ትደሊ፡ ክትመሃር፡ ወይ ሕብረት ክትገብር ትደሊ፡ ንዓኻካ/ኪ ዝኸውን ቦታ ኣሎና።',
      contactToStart: 'ክትጅምር ርኸቡና'
    },
    sermons: {
      title: 'ሰሙናዊ ስብከታት',
      search: 'ብኣርእስቲ ወይ ዕለት ድለዩ...',
      watching: 'ይርኢ ኣሎ',
      noResults: 'ስብከት ኣይተረኽበን',
      loadMore: 'ተወሳኺ ጽዕን'
    },
    livestream: {
      title: 'ቀጥታ ስርጭት',
      subtitle: 'ካብ ዝኾነ ቦታ ንዓይልና፡ ፀሎትን ምስአትን ተሳተፉ',
      liveNow: 'ህሉው ቀጥታ',
      watchingNow: 'ሕጂ ይርእዩ ኣለው',
      noLiveStream: 'ህሉው ቀጥታ ስርጭት የለን',
      noLiveMessage: 'ሓድሽ ስብከታት ርአዩ ወይ ንዝመፅእ ኣገልግሎታት ንታሕቲ ርአዩ',
      watchLatestSermons: 'ሓድሽ ስብከታት ርአዩ',
      visitYouTube: 'ናይና YouTube ቻናል ርአዩ',
      startedAt: 'ተጀሚሩ',
      serviceSchedule: 'ፕሮግራም ኣገልግሎታት',
      serviceScheduleSubtitle: 'ንቀጥታዊ ኣገልግሎታትና ተሳተፉ',
      joinInPerson: 'ብኣካል ምሳና ተሳተፉ',
      currentMeetingLocation: 'ህሉው ኣብ ቅዱስ ፊሎፓቴር ቆብጥ ኦርቶዶክስ ቤተ ክርስትያን ንረኽበሉ',
      howToWatch: 'ከመይ ጌርካ ትርእይ'
    },
    resources: {
      title: 'ሓበሬታ',
      subtitle: 'መልስታት ርኸቡን ናይ ቤተክርስቲያን ኣገልግሎታት ሕቶታት ስደዱን',
      requestForms: 'ሕቶ ቅጽፈታት',
      faqTitle: 'ተደጋጋሚ ሕቶታት',
      back: 'ተመለስ',
      
      // Baptism Form
      baptismRequest: 'ሕቶ ጥምቀት',
      baptismDescription: 'ንውላድካ ጥምቀት ሕተት',
      baptismFormTitle: 'ቅጽፈ ሕቶ ጥምቀት',
      childName: 'ሙሉእ ስም ውላድ',
      dateOfBirth: 'ዕለት ልደት',
      gender: 'ፆታ',
      selectGender: 'ፆታ ምረጽ',
      male: 'ተባዕታይ',
      female: 'ኣንስታይ',
      fatherName: 'ሙሉእ ስም ኣቦ',
      motherName: 'ሙሉእ ስም ኣደ',
      contactEmail: 'ናይ ርክብ ኢመይል',
      contactPhone: 'ናይ ርክብ ቴሌፎን',
      preferredBaptismDate: 'ዝመረጽክዎ ዕለት ጥምቀት',
      additionalNotes: 'ተወሳኺ ሓበሬታ',
      additionalNotesPlaceholder: 'ተወሳኺ ዝርዝራት...',
      
      // Wedding Form
      weddingRequest: 'ሕቶ መርዓው',
      weddingDescription: 'ናይ ቤተክርስቲያን መርዓውካ ግዜ ንምውሳን ሕተት',
      weddingFormTitle: 'ቅጽፈ ሕቶ መርዓው',
      groomName: 'ሙሉእ ስም ሰብኣይ',
      brideName: 'ሙሉእ ስም ሰበይቲ',
      preferredWeddingDate: 'ዝመረጽክዎ ዕለት መርዓው',
      
      // Counseling Form
      counselingRequest: 'ሕቶ ምኽሪ',
      counselingDescription: 'መንፈሳዊ ወይ ውልቃዊ ምኽሪ ሕተት',
      counselingFormTitle: 'ቅጽፈ ሕቶ ምኽሪ',
      fullName: 'ሙሉእ ስም',
      email: 'ኢመይል',
      phone: 'ቴሌፎን',
      counselingType: 'ዓይነት ምኽሪ',
      selectType: 'ዓይነት ምረጽ',
      personal: 'ውልቃዊ',
      family: 'ስድራቤት',
      youth: 'መንእሰያት',
      other: 'ካልእ',
      messageDetails: 'መልእኽቲ / ዝርዝራት',
      counselingPlaceholder: 'ብዛዕባ ናይ ምኽሪ ሕቶኻ ዝርዝር ኣካፍል...',
      
      // Membership Form
      membershipRequest: 'ኣባልነት ቤተክርስቲያን',
      membershipDescription: 'ናይ ቤተክርስቲያን ኣባል ንምዃን ኣመልክት',
      membershipFormTitle: 'ቅጽፈ ኣመልካት ኣባልነት ቤተክርስቲያን',
      address: 'ኣድራሻ',
      whyJoin: 'ንምንታይ ናብ ቤተክርስቲያን ክትእቱ ትደሊ?',
      reasonPlaceholder: 'ንምንታይ ናብ ቤተክርስቲያን ክትእቱ ከምዘለኻ ሰበብካ ኣካፍል...',
      
      // Form Actions
      submitting: 'ይስደድ ኣሎ...',
      submitRequest: 'ሕቶ ስደድ',
      baptismSuccess: 'ጥምቀት ሕቶ ተላኢኹ! ቀልጢፍና ክንርከበኩም ኢና።',
      weddingSuccess: 'መርዓው ሕቶ ተላኢኹ! ቀልጢፍና ክንርከበኩም ኢና።',
      counselingSuccess: 'ምኽሪ ሕቶ ተላኢኹ! ቀልጢፍና ክንርከበኩም ኢና።',
      membershipSuccess: 'ኣመልካት ኣባልነት ተላኢኹ! ቀልጢፍና ክንርከበኩም ኢና።',
      submitError: 'ሕቶ ምስዳድ ኣይተኻእለን'
    },
    gallery: {
      title: 'ስእሊታት',
      subtitle: 'ካብ ናይ ሕበረት ግዜታት',
      filterPhotos: 'ስእልታት ምርጫ',
      allDates: 'ዅሉ ዕለታት',
      allLocations: 'ዅሉ ቦታታት',
      clearFilters: 'ኵሉ ምርጫታት ኣጽርይ',
      showing: 'የርኢ ኣሎ',
      of: 'ካብ',
      photos: 'ስእልታት',
      noPhotos: 'ዘርእዩ ስእልታት የለን'
    },
    donate: {
      title: 'ደገፍ ቤተክርስትያንና',
      subtitle: 'ኣብ ምህናጽ ቀዋሚ ቤተክርስትያንና ንኽንሃንጽ ሓገዝኩም ኣበርክቱ',
      selectAmount: 'መጠን ምርጫ',
      packages: {
        small: 'ደጋፊ',
        medium: 'በጀላ',
        large: 'ደገፋይ',
        generous: 'ልግዓይ ሃባይ',
        other: 'ካልእ',
        customAmount: 'ዝደለኹዎ መጠን'
      },
      donorInfo: 'መረጃ ሃባይ (መረጻ)',
      name: 'ሙሉእ ስም',
      email: 'ኢመይል',
      enterAmount: 'መጠን ኣእትዉ ($)',
      enterAmountPlaceholder: 'መጠን ኣእትዉ',
      monthlyRecurring: 'ወርሓዊ ተደጋጋሚ ክፍሊት ግበሮ (መዐሸር)',
      startMonthlyTithe: 'ወርሓዊ መዐሸር ጀምር',
      submit: 'ንክፍሊት ቀጽል',
      success: 'ነመስግን!',
      successMessage: 'ደገግኩም ተቐቢልናዮ። እግዚኣብሔር ይባርኽኩም!',
      processing: 'ደገግኩም ይሰርሕ ኣሎ...',
      backToDonate: 'ካልእ ደገፍ',
      downloadReceipt: 'ደረሰኝ ኣውርድ (PDF)',
      invalidAmount: 'ዝቅተኛ መጠን $1 ኣእትው',
      
      // Building Campaign
      buildingCampaign: 'ዘመተ ህንፃ',
      prayerSanctuary: 'ቅድስና ፀሎት',
      prayerDescription: 'ንኣምልኾ ኣገልግሎታት፡ ፀሎትን መንፈሳዊ ኣኼባታትን',
      churchHall: 'ሓፈሻዊ ቤት',
      churchHallDescription: 'ንሰርግ፡ ጥምቐት፡ መታከር፡ በዓላት',
      youthMinistry: 'ንኣባይቲ ኣገልግሎት',
      youthDescription: 'ብእንግሊዝኛ ትምህርቲ፡ መጽሓፍቲ ቤት'
    },
    contact: {
      title: 'ርኸቡና',
      address: 'ኣድራሻ',
      email: 'ኢመይል',
      phone: 'ቴሌፎን',
      followUs: 'ተኸታተሉና',
      sendMessage: 'መልእክቲ ስደዱ',
      name: 'ስም',
      message: 'መልእክቲ',
      submit: 'ስደድ'
    },
    admin: {
      title: 'ኣስተዳዳሪ ክፍሊ',
      login: 'ኣስተዳዳሪ መእተዊ',
      email: 'ኢመይል',
      password: 'ፓስዎርድ',
      username: 'ስም ተጠቃሚ',
      signIn: 'እቶ',
      register: 'ምዝገባ',
      dashboard: 'ዳሽቦርድ',
      overview: 'ሓፈሻዊ እይታ',
      allPages: 'ዅሉ ገጻት',
      formSubmissions: 'ተላኢኹ ቅጽፈታት',
      advancedContent: 'ዝሓለፈ ትሕዝቶ',
      content: 'ትሕዝቶ ሚደር',
      gallery: 'ስእሊ',
      announcements: 'ምልክታታት',
      livestream: 'ቀጥታ መድብ',
      donations: 'ደገፍ',
      logout: 'ውጻእ',
      sessionExpired: 'ግዜኻ ወዲኡ። በጃኻ ደጊምካ እቶ።',
      logoutSuccess: 'ብዓወት ወፂእካ'
    },
    footer: {
      description: 'ኤርትራዊት ኦርቶዶክስ ተዋሕዶ መካነ ህይወት ኢየሱስ ኣብ ዳላስን ከባቢኡን ካብ 2016 ጀሚሩ ኣገልግሎት ይህብ ኣሎ',
      quickLinks: 'ቀልጢፍ መወከሲታት',
      connectWithUs: 'ምሳና ተራኸቡ',
      copyright: '© 2025 መካነ ህይወት ኢየሱስ ኦርቶዶክስ ተዋሕዶ ቤተክርስትያን። ኩሉ መሰላት ተሓሊዩ።'
    }
  }
};

export const t = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key;
    }
  }
  
  return value || key;
};
